import { template, templateSettings } from 'lodash';
import { IActionHandler } from './IActionHandler';

export abstract class ActionOnFieldHandler implements IActionHandler {
  fieldName: string;

  actionPropertiesSupported = {
    PLACEHOLDER: 'placeholder',
  };

  protected constructor(fieldName: string) {
    this.fieldName = fieldName;
  }

  protected hasField(action: any) {
    return action[this.fieldName];
  }

  canHandleAction(action: any): boolean {
    return this.hasField(action);
  }

  getAction(action: any): any {
    return action && action[this.fieldName];
  }

  hasPlaceholder(action: any): boolean {
    return action && action[this.actionPropertiesSupported.PLACEHOLDER];
  }

  abstract handleAction(
    action: any,
    data: any,
    subActionHandle?: (action: any) => Promise<void>
  ): Promise<void>;

  placeholderBuilder(action, text: string, data): string {
    if (this.hasPlaceholder(action)) {
      const placeholderFields = action[this.actionPropertiesSupported.PLACEHOLDER];
      const placeholderData = {};
      placeholderFields.forEach((field) => {
        placeholderData[field] = data[field];
      });
      templateSettings.interpolate = /{{([\s\S]+?)}}/g;
      const compiled = template(text);
      return compiled(placeholderData);
    }
    return text;
  }
}
